"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class FeedItemModel extends _1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            parentId: 'ParentId'
        };
    }
}
exports.FeedItemModel = FeedItemModel;
//# sourceMappingURL=feed-item.model.js.map